import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Plus } from "lucide-react";
import api from "../../lib/apiClient";
import { ProHeader, StatusBadge, fmtDate, Loading, Empty } from "./proUi";

// Réservations : vue des créneaux réservés (BOOKED) + aperçu des créneaux libres.
// La gestion complète (ajout/suppression) reste sur /pro/disponibilites (anti double-booking backend).
export default function ProReservations() {
  const [slots, setSlots] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/marketplace/availability/me").then((r) => setSlots(r.data.slots)).catch(() => setSlots([])); }, []);
  if (slots === null) return <Loading />;
  const booked = slots.filter((s) => s.status === "BOOKED");
  const open = slots.filter((s) => s.status === "OPEN");
  return (
    <div className="space-y-6" data-testid="pro-reservations-page">
      <ProHeader eyebrow="Mon activité" title="Mes réservations"
        subtitle="Retrouve les créneaux réservés par tes clients et tes disponibilités à venir." />

      <section>
        <h2 className="font-display text-lg font-bold mb-2">Créneaux réservés</h2>
        {booked.length === 0 ? (
          <Empty icon={CalendarClock} title="Aucune réservation" hint="Les créneaux réservés lors de l'acceptation d'un devis s'afficheront ici." testid="pro-reservations-empty" />
        ) : (
          <div className="space-y-2">
            {booked.map((s) => (
              <div key={s.id} className="flex items-center justify-between gap-2 bg-[#18181E] border border-zinc-800 rounded-xl px-4 py-3" data-testid={`reservation-${s.id}`}>
                <span className="text-sm text-zinc-200 inline-flex items-center gap-2"><CalendarClock className="w-4 h-4 text-violet-400" />{fmtDate(s.start)} → {fmtDate(s.end)}</span>
                <StatusBadge status="DELIVERED" />
              </div>
            ))}
          </div>
        )}
      </section>

      <section>
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-display text-lg font-bold">Créneaux libres ({open.length})</h2>
          <button onClick={() => nav("/pro/disponibilites")} data-testid="reservations-manage" className="inline-flex items-center gap-1.5 text-sm text-amber-400"><Plus className="w-4 h-4" />Gérer mes disponibilités</button>
        </div>
        {open.length === 0 ? (
          <p className="text-sm text-zinc-500">Aucun créneau libre. Ajoute des disponibilités pour permettre les réservations.</p>
        ) : (
          <div className="grid gap-2 sm:grid-cols-2">
            {open.map((s) => (
              <div key={s.id} className="flex items-center justify-between gap-2 bg-[#18181E] border border-zinc-800 rounded-xl px-4 py-2.5" data-testid={`slot-open-${s.id}`}>
                <span className="text-sm text-zinc-300 inline-flex items-center gap-2"><CalendarClock className="w-4 h-4 text-emerald-400" />{fmtDate(s.start)} → {fmtDate(s.end)}</span>
                <StatusBadge status="OPEN" />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
